import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartPie,
    FaMapMarkedAlt,
    FaChartLine,
    FaUsers,
    FaHome,
    FaSyringe,
    FaClipboardList,
    FaUserMd
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import SummaryWrapper from './Summary';
import GeneralProductionWrapper from './GeneralProduction';
import StratifiedProductionWrapper from './StratifiedProduction';
import HouseHoldVisitWrapper from './HouseHoldVisit';
import VaccinationWrapper from './Vacination';
import ProceduresWrapper from './Procedures';
import ProfessionalsWrapper from './Professionals';
import MappingWrapper from './Mapping';

const menus = [
    {
        title: 'Resumo',
        path: '/governanceroom/dashboardproductionesus/production/summary',
        icon: <FaChartPie style={{ marginRight: '5px' }} />
    },
    {
        title: 'Mapeamento',
        path: '/governanceroom/dashboardproductionesus/production/mapping',
        icon: <FaMapMarkedAlt style={{ marginRight: '5px' }} />
    },
    {
        title: 'Prod. Geral',
        path: '/governanceroom/dashboardproductionesus/production/general-production',
        icon: <FaChartLine style={{ marginRight: '5px' }} />
    },
    {
        title: 'Prod. Estratificada',
        path: '/governanceroom/dashboardproductionesus/production/stratified-production',
        icon: <FaUsers style={{ marginRight: '5px' }} />
    },
    {
        title: 'Visita Domiciliar',
        path: '/governanceroom/dashboardproductionesus/production/home-visit',
        icon: <FaHome style={{ marginRight: '5px' }} />
    },
    {
        title: 'Vacinação',
        path: '/governanceroom/dashboardproductionesus/production/vaccination',
        icon: <FaSyringe style={{ marginRight: '5px' }} />
    },
    {
        title: 'Procedimentos',
        path: '/governanceroom/dashboardproductionesus/production/procedures',
        icon: <FaClipboardList style={{ marginRight: '5px' }} />
    },
    {
        title: 'Profissionais',
        path: '/governanceroom/dashboardproductionesus/production/professionals',
        icon: <FaUserMd style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardproductionesus/production/summary':
        'Resultados Gerais dos Indicadores de Atendimento',
    '/governanceroom/dashboardproductionesus/production/mapping':
        'Mapa da Unidades de Saúde',
    '/governanceroom/dashboardproductionesus/production/general-production':
        'Resultados Gerais da Produção Geral',
    '/governanceroom/dashboardproductionesus/production/stratified-production':
        'Resultados Gerais da Produção Estratificada',
    '/governanceroom/dashboardproductionesus/production/home-visit':
        'Resultados Gerais das Visitas Domiciliares',
    '/governanceroom/dashboardproductionesus/production/vaccination':
        'Resultados Gerais da Vacinação',
    '/governanceroom/dashboardproductionesus/production/procedures':
        'Resultados Gerais dos Procedimentos',
    '/governanceroom/dashboardproductionesus/production/professionals':
        'Resultados Gerais dos Profissionais'
};

const Production = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardesus');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                    showServiceTypesStratified={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/stratified-production'
                    }
                    showServiceTypesProfessionals={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/professionals'
                    }
                    showHouseholdStatus={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/home-visit'
                    }
                    showImmunobiologicals={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/vaccination'
                    }
                    showImmunobiologicalsDoses={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/vaccination'
                    }
                    showProcedureGroup={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/procedures'
                    }
                    showProcedureSubgroup={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/procedures'
                    }
                    showProcedures={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/procedures'
                    }
                    showCbo={
                        location.pathname ===
                        '/governanceroom/dashboardproductionesus/production/professionals'
                    }
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="summary" replace />}
                        />
                        <Route path="summary" element={<SummaryWrapper />} />
                        <Route path="mapping" element={<MappingWrapper />} />
                        <Route
                            path="general-production"
                            element={<GeneralProductionWrapper />}
                        />
                        <Route
                            path="stratified-production"
                            element={<StratifiedProductionWrapper />}
                        />
                        <Route
                            path="home-visit"
                            element={<HouseHoldVisitWrapper />}
                        />
                        <Route
                            path="vaccination"
                            element={<VaccinationWrapper />}
                        />
                        <Route
                            path="procedures"
                            element={<ProceduresWrapper />}
                        />
                        <Route
                            path="professionals"
                            element={<ProfessionalsWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Production;
